/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Keyword_Optimizer_Button_Apply_AllInputs */

const en_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apply all ${i?.count}`)
};

const de_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} übernehmen`)
};

const fr_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tout appliquer (${i?.count})`)
};

const es_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aplicar las ${i?.count}`)
};

const it_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Applica tutti (${i?.count})`)
};

const nl_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} toepassen`)
};

const pl_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zastosuj wszystkie (${i?.count})`)
};

const fi_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Käytä kaikkia (${i?.count})`)
};

const da_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anvend alle ${i?.count}`)
};

const sv_keyword_optimizer_button_apply_all = /** @type {(inputs: Keyword_Optimizer_Button_Apply_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tillämpa alla ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Apply all {count}" |
*
* @param {Keyword_Optimizer_Button_Apply_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_button_apply_all = /** @type {((inputs: Keyword_Optimizer_Button_Apply_AllInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Button_Apply_AllInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_button_apply_all(inputs)
	if (locale === "fr") return fr_keyword_optimizer_button_apply_all(inputs)
	if (locale === "es") return es_keyword_optimizer_button_apply_all(inputs)
	if (locale === "it") return it_keyword_optimizer_button_apply_all(inputs)
	if (locale === "nl") return nl_keyword_optimizer_button_apply_all(inputs)
	if (locale === "pl") return pl_keyword_optimizer_button_apply_all(inputs)
	if (locale === "fi") return fi_keyword_optimizer_button_apply_all(inputs)
	if (locale === "da") return da_keyword_optimizer_button_apply_all(inputs)
	if (locale === "sv") return sv_keyword_optimizer_button_apply_all(inputs)
	return en_keyword_optimizer_button_apply_all(inputs)
});